import React from 'react';
import { Box, Checkbox } from '@mui/material';
import {CheckboxCellProps} from './CheckboxCell.props';

export const CheckboxCell = (props: CheckboxCellProps) => ({
  forceComponent: true,
  component: (
    <Box display="flex" justifyContent="center">
      <Checkbox onChange={props.handleChange} {...props} />
    </Box>)
});